import type { BackgroundColorsPredefined } from '~/@types/cms';

export const useStyle = (prefix = 'bg') => {
    const colorMapper: Record<Partial<BackgroundColorsPredefined>, string> = {
        default: '',
        custom: `${prefix}-[--custom-background-color]`,
        black: `${prefix}-woom-black`,
        dark: `${prefix}-woom-black`,
        grey: `${prefix}-woom-grey`,
        mossgreen: `${prefix}-woom-green-moss`,
        light: `${prefix}-white`,
        white: `${prefix}-white`,
        dreamysky: `${prefix}-woom-blue-dreamy-sky-light`,
        softsprout: `${prefix}-woom-green-soft-sprout-light`,
        poppeach: `${prefix}-woom-orange-pop-peach-light`,
    };
    return { colorMapper };
};

const darkBackgrounds = ['black', 'dark'] as BackgroundColorsPredefined[];

export const useBackground = (background: BackgroundColorsPredefined) => {
    const { colorMapper } = useStyle();
    return { class: [colorMapper[background], { 'text-white': darkBackgrounds.includes(background) }] };
};
